import axios from 'axios';
import apiUrl from '../../../constants';

export function uploadImages(input, token){
    return axios({
        method: 'post',
        url: `${apiUrl.api_url}uploadimage`,
        data: input,
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })
}


// WEBPACK FOOTER //
// ./src/services/B2b/services/uploadImages.js